import React, { RefObject, useState } from 'react';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { PictureAsPdf } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { exportElementToPdf } from 'helpers/exportPdf';

interface SavePdfButtonProps {
  targetRef: RefObject<HTMLElement | null>;
  filename: string;
}

const SavePdfButton: React.FC<SavePdfButtonProps> = ({ targetRef, filename }) => {
  const [saving, setSaving] = useState(false);

  async function handleClick() {
    if (!targetRef.current || saving) return;

    setSaving(true);

    try {
      await exportElementToPdf(targetRef.current, { filename });
    } catch {
      toast.error('Não foi possível gerar o PDF');
    } finally {
      setSaving(false);
    }
  }

  return (
    <Tooltip title="Salvar PDF">
      <span>
        <IconButton onClick={handleClick} disabled={saving} aria-label="Salvar PDF">
          {saving ? <CircularProgress size={18} /> : <PictureAsPdf fontSize="small" />}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default SavePdfButton;
